import { render, staticRenderFns } from "./proLayout.vue?vue&type=template&id=01d573aa&scoped=true&"
import script from "./proLayout.vue?vue&type=script&lang=ts&"
export * from "./proLayout.vue?vue&type=script&lang=ts&"
import style0 from "./proLayout.vue?vue&type=style&index=0&id=01d573aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d573aa",
  null
  
)

export default component.exports